import { from, Observable, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';

/**
 *
 * @param error  Handles errors by extracting and formatting the error message from an error object.
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function errorHandle(error: any): Observable<never> {
  if (error.error instanceof Blob) {
    return from(error.error.text() as Promise<string>).pipe(
      switchMap((text: string) => {
        try {
          const json = JSON.parse(text);
          return throwError(() => json.message ?? error.message);
        } catch {
          return throwError(() => error.message);
        }
      }),
    );
  }

  let errorMessage = '';
  if (error.error?.message) {
    errorMessage = error.error.message;
  } else {
    errorMessage = error.message ? error.message : error;
  }

  return throwError(() => errorMessage);
}
